import { TEXT_MUTED } from './analyticsTokens';

interface LegendDotProps {
  color: string;
  label: string;
  /** Dot diameter in px. Default 16 (Content Analysis bottom legend). */
  size?: number;
  /** Spacing between dot and label in px. Default 16. */
  gap?: number;
}

/**
 * Single legend swatch used across the analytics charts.
 * Colored circle + 12px Manrope 400 #9B919D label.
 *
 * Two callsite sizes coexist: chart-card headers use 12×12 with gap 8 to fit
 * alongside the card title; standalone bottom legends use the default 16×16
 * with gap 16 for prominence.
 */
const LegendDot = ({ color, label, size = 16, gap = 16 }: LegendDotProps) => (
  <div className="flex items-center" style={{ gap }}>
    <span
      style={{
        width: size,
        height: size,
        borderRadius: size,
        background: color,
      }}
    />
    <span
      style={{
        fontFamily: 'Manrope',
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '100%',
        color: TEXT_MUTED,
      }}
    >
      {label}
    </span>
  </div>
);

export default LegendDot;
